var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/category/business/"}},[_vm._v("BUSINESS")])}
var staticRenderFns = []

export { render, staticRenderFns }